export const STATUS = {
  'Em Processamento': {
    label: 'Em Processamento',
    style: 'warning-light'
  },
  'Integrado/Pronto para implantação': {
    label: 'Integrado',
    style: 'success-light'
  },
  Erro: {
    label: 'Erro',
    style: 'error-light'
  },
  Finalizado: {
    label: 'Finalizado',
    style: 'outlined'
  }
}
